/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardArrowLeft: {
  name: 'keyboard-arrow-left';
  data: string;
} = {
  name: 'keyboard-arrow-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>`
};
